import { FC, MouseEventHandler } from 'react';

interface Props {
  className?: string;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const ButtonOutline: FC<Props> = ({
  className,
  disabled,
  children,
  ...rest
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
  };

  return (
    <button
      onClick={handleClick}
      type="submit"
      aria-label="submit"
      className={'px-4 h-10 mt-4 text-sm border-indigo-500 border text-indigo-500 w-40 ml-4 rounded shadow-md focus:outline-none z-20 relative'}
      {...rest}
    >
      {children}
    </button>
  );
};

export default ButtonOutline;
